import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { MdCheck, MdFileCopy, MdHighlightOff } from "react-icons/md";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

const JsonBlock = ({ label, dotColor, data, copied, onCopy }: {
  label: string; dotColor: "blue" | "green";
  data: any; copied: boolean; onCopy: () => void;
}) => (
  <div className="sub-json-section">
    <div className="sub-json-header">
      <div className="sub-json-label">
        <div className={`sub-json-dot sub-json-dot--${dotColor}`} />
        {label}
      </div>
      <button className={`sub-copy-btn${copied ? " sub-copy-btn--copied" : ""}`} onClick={onCopy}>
        {copied ? <><MdCheck size={14} />Copied!</> : <><MdFileCopy size={14} />Copy</>}
      </button>
    </div>
    <div className="sub-json-wrap">
      <pre className="sub-json-pre">{JSON.stringify(data, null, 2)}</pre>
    </div>
  </div>
);

const InfoModalSubscription = ({ info, varient }: { info?: any; varient?: string }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [copyPayment, setCopyPayment] = React.useState(false);
  const [copyGateway, setCopyGateway] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("payment");
  const [isCloseModal, setIsCloseModal] = React.useState(false);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const copy = (data: any, setter: (v: boolean) => void) => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    setter(true); setTimeout(() => setter(false), 1500);
  };

  const TABS = [
    { id: "payment", label: "Payment Response", icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg> },
    { id: "gateway", label: "Gateway Response", icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg> },
  ];

  return (
    <>
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <button
            className="sub-info-trigger"
            onClick={() => { setActiveTab("payment"); onOpen(); }}
            disabled={!info}
            aria-label="View subscription info"
          >
            <BsInfoCircleFill size={varient === "small" ? 13 : 14} />
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="230px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="14px" py="10px">
            View Subscription Info
          </PopoverHeader>
          <PopoverArrow bg="#eff6ff" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />

        <div className={`sub-info-panel${isOpen && !isCloseModal ? " sub-info-panel--open" : " sub-info-panel--close"}`}>
          <div className="sub-info-glow" />

          <div className="sub-info-header">
            <div className="sub-info-header-brand">
              <div className="sub-info-header-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                </svg>
              </div>
              <div>
                <h2 className="sub-info-title">Subscription Info</h2>
                <p className="sub-info-sub">Transaction &amp; gateway response details</p>
              </div>
            </div>
            <button className="sub-info-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          {/* Tab bar */}
          <div className="sub-info-tab-bar">
            {TABS.map((t) => (
              <button key={t.id} className={`sub-info-tab${activeTab === t.id ? " sub-info-tab--active" : ""}`} onClick={() => setActiveTab(t.id)}>
                {t.icon}{t.label}
              </button>
            ))}
          </div>

          <div className="sub-info-body">
            {activeTab === "payment" && (
              <div className="sub-info-content">
                <JsonBlock
                  label="Payment Response" dotColor="blue"
                  data={info?.payment?.[0]?.meta_info} copied={copyPayment}
                  onCopy={() => copy(info?.payment?.[0]?.meta_info, setCopyPayment)}
                />
              </div>
            )}
            {activeTab === "gateway" && (
              <div className="sub-info-content">
                {info?.gateway_response && Object.keys(info.gateway_response).length > 0 ? (
                  <JsonBlock
                    label="Gateway Response" dotColor="green"
                    data={info?.gateway_response} copied={copyGateway}
                    onCopy={() => copy(info?.gateway_response, setCopyGateway)}
                  />
                ) : (
                  <div className="sub-info-empty">
                    <div className="sub-info-empty-icon">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </div>
                    <p className="sub-info-empty-title">No gateway response</p>
                    <p className="sub-info-empty-desc">Gateway response not available for this subscription.</p>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="sub-info-footer">
            <div className="sub-info-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Read-only subscription data
            </div>
            <button className="sub-info-btn-close" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .sub-info-trigger { display:inline-flex; align-items:center; justify-content:center; width:28px; height:28px; border-radius:7px; background:#eff6ff; border:1.5px solid #bfdbfe; color:#2563eb; cursor:pointer; transition:all .15s; }
        .sub-info-trigger:hover { background:#dbeafe; border-color:#93c5fd; }
        .sub-info-trigger:disabled { opacity:.45; cursor:not-allowed; }

        .sub-info-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:640px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
        .sub-info-panel--open  { transform:translateX(0); }
        .sub-info-panel--close { transform:translateX(100%); }

        .sub-info-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#0f2744,#2563eb,#7c3aed,#2563eb,#0f2744); background-size:200% 100%; animation:subInfoGlow 3s linear infinite; }
        @keyframes subInfoGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .sub-info-header { padding:15px 26px; background:linear-gradient(135deg,#0f2744 0%,#1a3d6b 60%,#1d4ed8 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .sub-info-header-brand { display:flex; align-items:center; gap:13px; }
        .sub-info-header-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .sub-info-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
        .sub-info-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
        .sub-info-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
        .sub-info-close:hover { color:#fff; }

        .sub-info-tab-bar { display:flex; border-bottom:1.5px solid #e2e8f0; background:#fafbfc; flex-shrink:0; padding:0 24px; }
        .sub-info-tab { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:14px 16px; border:none; background:none; border-bottom:2.5px solid transparent; cursor:pointer; transition:all .18s; margin-bottom:-1.5px; }
        .sub-info-tab:hover { color:#1d4ed8; }
        .sub-info-tab--active { color:#1d4ed8; border-bottom-color:#2563eb; font-weight:700; }

        .sub-info-body { flex:1; overflow-y:auto; background:#f8fafc; }
        .sub-info-body::-webkit-scrollbar { width:4px; }
        .sub-info-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

        .sub-info-content { padding:20px 24px; display:flex; flex-direction:column; gap:20px; }

        .sub-json-section { background:#fff; border:1px solid #e2e8f0; border-radius:14px; overflow:hidden; }
        .sub-json-header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; background:#f8fafc; border-bottom:1px solid #f1f5f9; }
        .sub-json-label { display:flex; align-items:center; gap:8px; font-size:12px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
        .sub-json-dot { width:8px; height:8px; border-radius:50%; flex-shrink:0; }
        .sub-json-dot--blue  { background:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.15); }
        .sub-json-dot--green { background:#16a34a; box-shadow:0 0 0 3px rgba(22,163,74,.15); }
        .sub-copy-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:600; color:#64748b; padding:5px 12px; border-radius:7px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .sub-copy-btn:hover { background:#f1f5f9; }
        .sub-copy-btn--copied { color:#15803d; border-color:#bbf7d0; background:#f0fdf4; }
        .sub-json-wrap { overflow:auto; max-height:420px; }
        .sub-json-wrap::-webkit-scrollbar { width:4px; height:4px; }
        .sub-json-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
        .sub-json-pre { margin:0; padding:16px 18px; font-family:'JetBrains Mono','Fira Code','Courier New',monospace; font-size:12.5px; line-height:1.65; color:#1e293b; white-space:pre; background:#fff; }

        .sub-info-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
        .sub-info-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
        .sub-info-empty-title { font-size:14px; font-weight:700; color:#64748b; }
        .sub-info-empty-desc { font-size:12.5px; color:#94a3b8; font-weight:500; text-align:center; }

        .sub-info-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .sub-info-footer-note { display:flex; align-items:center; gap:6px; font-size:12px; color:#94a3b8; font-weight:500; }
        .sub-info-btn-close { font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:600; color:#64748b; padding:10px 24px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .sub-info-btn-close:hover { background:#f1f5f9; }

        @media (max-width:520px) { .sub-info-panel { max-width:100%; } .sub-info-header { padding:16px 18px; } .sub-info-content { padding:16px; } .sub-info-tab-bar { padding:0 16px; } }
      `}</style>
    </>
  );
};

export default InfoModalSubscription;